// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"478":"30da227e","895":"30da227e","908":"aaaef480"}[chunkId] + ".chunk.css";
};